import { message } from "antd"
import { auth } from "./index"
import nookies from "nookies"

export async function Logout() {
  const loggingOut = message.loading("Cerrando sesión")
  await auth.signOut()
  nookies.destroy(null, "token", { path: "/" })
  nookies.destroy(null, "2FAToken", { path: "/" })
  window.location.href = "/"
  loggingOut()
}

